import Delta from "quill-delta";
import { websiteValidationPattern } from "tools/validations";
import { matchPath } from "react-router-dom";
import { QuillMatcher } from "view/components/RichTextEditor/types";
import { SHOW_INFO_PATH } from "view/routes";
import getSearchParamsObject from "tools/common/getSearchParamsObject";
import { ITerm } from "@evennt-tech/api-v2-core";

type SearchParams = {
  category?: string;
  termId?: string;
};
const termUrlMatcher = (
  showId: string,
  glossaryTerms: ITerm[] | undefined,
  errorColor: string
): QuillMatcher => {
  return [
    Node.TEXT_NODE,
    (node: any, delta: Delta) => {
      const nodeData = node?.data;

      if (typeof nodeData === "string") {
        const isUrl = websiteValidationPattern.test(nodeData);
        if (isUrl) {
          const encodedUrl = nodeData.replace(/%20/g, " ");

          const url = new URL(encodedUrl);
          const matched = matchPath(SHOW_INFO_PATH, url.pathname);

          const {
            category: searchParamCategory,
            termId: searchParamTermId,
          } = getSearchParamsObject<SearchParams>(
            new URLSearchParams(url.search)
          );
          if (!matched || !searchParamTermId || !searchParamCategory) {
            return delta;
          }
          const urlShowId = matched?.params?.showId;
          if (urlShowId !== showId) {
            const errorMessage =
              "Error: Links can only be used within the same show";
            return new Delta().insert(errorMessage, {
              color: errorColor,
              underline: true,
            });
          }

          const term = glossaryTerms?.find(
            (term) => term.id === searchParamTermId
          );
          if (term) {
            return new Delta().insert(term.title, {
              link: encodedUrl,
            });
          }
          return delta;
        }
        return delta;
      }
      return delta;
    },
  ];
};

export default termUrlMatcher;
